import {Injectable} from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {
  catchError,
  from,
  Observable,
  of,
  switchMap,
  tap,
  throwError,
} from 'rxjs';

import {Router} from '@angular/router';
import {LocalStorageService} from "../services/local-storage.service";
import {NotificationService} from "../services/notification.service";
import {PathEnum} from "../shared/enums/path-enum";
import {NavController} from "@ionic/angular/standalone";


@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {

    private isRedirectingToLogin = false;

    constructor(
        private localStorageService: LocalStorageService,
        private router: Router,
        private notificationService: NotificationService,
        private navCtrl: NavController,
    ) {
    }

    intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Skip auth-related endpoints
        if (httpRequest.url.includes('login') || httpRequest.url.includes('token')
            || httpRequest.url.includes('auth/callback') || httpRequest.url.includes('/passkey/')
            || httpRequest.url.includes('auth/logout')) {
            return next.handle(httpRequest);
        }

        if (httpRequest.method !== 'OPTIONS') {
            return this.handleRequest(httpRequest, next);
        } else {
            return next.handle(httpRequest);
        }
    }

    handleRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // @ts-ignore
        return next.handle(request).pipe(
            catchError(
                (error: HttpErrorResponse) => {
                    if (error.status === 401) {
                        if (this.isRedirectingToLogin) {
                            return of(null);
                        }
                        this.isRedirectingToLogin = true;
                        return this.localStorageService.cleanPreferenceToken$().pipe(
                            switchMap(() => from(this.notificationService.closeAll())),
                            switchMap(() => from(
                                this.navCtrl.navigateRoot(PathEnum.LOGIN, {
                                    replaceUrl: true,
                                    state: {sessionExpired: true}
                                }).then(
                                    () => this.isRedirectingToLogin = false,
                                    () => this.isRedirectingToLogin = false
                                )
                            )),
                            tap(() => this.notificationService.openToast({
                                message: 'Sessione scaduta. Effettua nuovamente il login.',
                                color: 'warning'
                            })),
                            switchMap(() => of(null))
                        );
                    } else if (error?.status === 403 && error?.error?.code === 1009) {
                        this.router.navigateByUrl(PathEnum.PAGES + PathEnum.HOME).then();
                        return of(null);
                    } else {
                        return throwError(() => error);
                    }
                }));
    }
}
